<template>
  <v-card>
    <v-toolbar dark tile flat class="title text-center text-md-left" color="accent">
        <v-icon left>fas fa-exclamation-triangle</v-icon>
        Before we begin...
    </v-toolbar>
    <v-card-text>
        <v-row no-gutters>
            <v-col cols="12" class="subtitle-1">
                As you create your request please be aware these will be viewed in light of <a href="https://docs.google.com/document/d/1PnQXs2Vax8F6rQe-ZGA4WDI6huSMl9es96rVS4vQLvI/edit?usp=sharing" target="_blank" class="accent--text">The Mount's Communication Guidelines</a>. Also, you may want to peek at <router-link to="/Calendar" class="accent--text">The Mount's Online Calendar</router-link> to ensure your requested date is available. 
            </v-col>
            <v-col>
                <v-checkbox v-model="confirm" label="I am aware of this information and am ready to proceed." color="accent"></v-checkbox>
            </v-col>
            <v-col cols="12" class="text-center text-md-right">
                <v-btn outlined :disabled="!confirm" @click="$router.push('/New')">
                    <v-icon left small>fas fa-check</v-icon>
                    Proceed
                </v-btn>
            </v-col>
            <br>
        </v-row>
        <v-row no-gutters>
        
        </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    
  },
  data(){
    return {
      confirm: false
    }
  }
}
</script>
